import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  PictureBackgroundImageStyles,
  PictureBgImageObjectFit,
  PictureBgImagePosition,
} from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'fl-section-hero-background-image',
  template: `
    <fl-picture
      [src]="src"
      [srcTablet]="srcTablet"
      [srcDesktop]="srcDesktop"
      [alt]="alt"
      [isBackgroundImage]="true"
      [backgroundStyles]="backgroundStyles"
    >
    </fl-picture>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeroBackgroundImageComponent {
  @Input() alt: string;
  @Input() src: string;
  @Input() srcTablet?: string;
  @Input() srcDesktop?: string;
  @Input() srcLargeDesktop?: string;
  @Input() backgroundStyles?: PictureBackgroundImageStyles = {
    position: PictureBgImagePosition.CENTER_TOP,
    objectFit: PictureBgImageObjectFit.COVER,
  };
}
